import { ActivityType, RiskCategory, RoleId } from '../../amorg-common';
export const ColorNormal = `hsl(210, 100%, 70%)`;
export const ColorLight = `hsl(210, 100%, calc(70% + 20%))`;
export const ColorDark = `hsl(210, 100%, calc(70% - 50%))`;


export const TextNormal = "rgba(0, 0, 0, 1)";

export const rawColors = {
    blue: {
        normal: "rgba(120, 184, 255, 1)",
        dark: "rgba(0, 77, 163, 1)",
        darkExtreme: "rgba(16, 15, 50, 1)",
        light: "rgba(189, 220, 255, 1)",
        lightExtreme: "rgba(232, 243, 255, 1)"
    },
    gray: {
        normal: "rgba(120, 120, 120, 1)",
        dark: "rgba(63, 63, 63, 1)",
        darkExtreme: "rgba(43, 43, 43, 1)",
        light: "rgba(189, 189, 189, 1)",
        lightExtreme: "rgba(240, 240, 240, 1)",
        lightExtremeSuper: "rgba(248, 248, 248, 1)",
        normalOpacity: "rgba(120, 120, 120, 0.5)",
    },
    red: {
        normal: "rgba(201, 39, 79, 1)",
        dark: "rgba(135, 14, 45, 1)",
        light: "rgba(255, 139, 168, 1)",

    },
    green: {
        normal: "rgba(56, 117, 30, 1)",
        dark: "rgba(39, 81, 21, 1)",
        light: "rgba(126, 177, 104, 1)",

    },
    yellow: {
        normal: "rgba(215, 212, 51, 1)",
        dark: "rgba(185, 182, 21, 1)",
        light: "rgba(255, 255, 122, 1)",
    },
    beige: {
        normal: "rgb(222, 215, 199)",
        dark: "rgb(189, 177, 149)",
    },
    white: "white",
    black: "black"
};

const cardBorder = 'rgb(222,222,222)';

const background = {
    white: 'white',
    beige: rawColors.beige.normal,
    gray: rawColors.gray.lightExtreme,
};

const stateColors = {

    // these two should be removed - are not general enough
    pending: rawColors.gray.normal,
    info: rawColors.blue.dark,

    success: rawColors.green.normal,
    warning: rawColors.yellow.dark,
    error: rawColors.red.normal
};


// How about just light, normal, disabled and state (success, error, warning) ?
const textColors = {
    normal: rawColors.gray.dark,

    // what does muted mean ? vs light ?
    muted: rawColors.gray.light,

    // Can we make do with just one light text ?
    light: rawColors.gray.light,
    lightExtreme: rawColors.gray.lightExtreme,

    gray: {
        contrastForWhite: 'rgb(88,88,88)',
        normal: rawColors.gray.normal,
        dark: rawColors.gray.dark,
        light: rawColors.gray.light,
        lightExtreme: rawColors.gray.lightExtreme
    },
    state: stateColors,
    inactive: rawColors.gray.light,
    highlighted: rawColors.blue.normal,
    white: rawColors.white
};

const inputState = {
    default: {
        border: rawColors.blue.light,
        borderHover: rawColors.blue.normal,
        borderActive: rawColors.blue.normal,
        borderFocus: rawColors.blue.normal,
        text: rawColors.gray.dark,
        placeholderText: textColors.light
    },
    error: {
        border: rawColors.red.light,
        borderHover: rawColors.red.dark,
        borderActive: rawColors.red.dark,
        borderFocus: rawColors.red.dark,
        text: textColors.state.error,
        placeholderText: textColors.light
    },
    // Should be made reusable - lots of use cases
    disabled: {
        background: rawColors.gray.lightExtreme,
        border: rawColors.gray.light,
        text: textColors.muted,
        placeholderText: textColors.muted
    }
};

// export const amorgColors:CustomizableColors = {
//     primary:{
//         light:rawColors.blue.light,
//         normal:rawColors.blue.normal,
//         dark:rawColors.blue.dark,
//     },

//     mainNavigation:{
//         background:rawColors.blue.darkExtreme,
//         backgroundSelected:rawColors.blue.normal,
//         divider:rawColors.blue.normal
//     },
// };



//TODO: derive less used components from core components.
// Eg. should tabber use stylin from filled button ?

export const colors = {
    mainNavigation: {
        background: rawColors.blue.darkExtreme,
        backgroundSelected: rawColors.blue.normal,
        divider: rawColors.blue.normal,
        color: textColors.white,
        colorSelected: textColors.white,
    },
    button2: {
        outlined: {
            default: { border: rawColors.blue.light, background: rawColors.white, text: rawColors.blue.dark },
            hover: { border: rawColors.blue.light, background: rawColors.blue.light, text: rawColors.blue.dark },
            active: { border: rawColors.blue.normal, background: rawColors.blue.dark, text: rawColors.white },
            disabled: { border: rawColors.gray.light, background: rawColors.gray.lightExtreme, text: rawColors.gray.light }
        }
    },
    button: {
        filled: {
            border: "0",
            text: textColors.white,
            textHover: textColors.white,
            textDisabled: textColors.light,
            background: rawColors.blue.normal,
            backgroundHover: rawColors.blue.dark,
            backgroundDisabled: inputState.disabled.background
        },
        outlined: {
            border: `1px solid ${rawColors.blue.light}`,
            text: rawColors.blue.dark,
            textHover: rawColors.blue.dark,
            textDisabled: textColors.light,
            background: background.white,
            backgroundHover: rawColors.blue.light,
            backgroundDisabled: background.white
        },
        text: {
            border: `0`,
            text: rawColors.blue.dark,
            textHover: rawColors.blue.dark,
            textDisabled: textColors.light,
            background: 'transparent',
            backgroundHover: rawColors.blue.light,
            backgroundDisabled: 'transparent'
        },
        light: {
            border: `0`,
            text: rawColors.blue.dark,
            textHover: rawColors.blue.dark,
            textDisabled: textColors.light,
            background: rawColors.blue.light,
            backgroundHover: rawColors.blue.normal,
            backgroundDisabled: inputState.disabled.background
        },
        destructive: {
            border: `0`,
            text: rawColors.white,
            textHover: rawColors.white,
            textDisabled: rawColors.gray.light,
            background: rawColors.red.normal,
            backgroundHover: rawColors.red.dark,
            backgroundDisabled: rawColors.gray.lightExtreme
        },
        destructiveText: {
            border: `0`,
            text: rawColors.red.normal,
            textHover: rawColors.white,
            textDisabled: rawColors.gray.light,
            background: `transparent`,
            backgroundHover: rawColors.red.normal,
            backgroundDisabled: 'transparent'
        },
        clean: {
            border: `0`,
            text: textColors.normal,
            textHover: textColors.normal,
            textDisabled: rawColors.gray.light,
            background: `transparent`,
            backgroundHover: `transparent`,
            backgroundDisabled: 'transparent'
        },
        dimmed: {
            border: `0`,
            text: textColors.muted,
            textHover: textColors.normal,
            textDisabled: rawColors.gray.light,
            background: `transparent`,
            backgroundHover: `transparent`,
            backgroundDisabled: 'transparent'
        }
    },
    card: {
        light: {
            default: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            hover: {
                border: cardBorder,
                background: rawColors.blue.normal,
                color: rawColors.gray.dark
            },
            active: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        lightGray: {
            default: {
                border: cardBorder,
                background: rawColors.gray.lightExtremeSuper,
                color: rawColors.gray.dark
            },
            hover: {
                border: cardBorder,
                background: rawColors.gray.light,
                color: rawColors.gray.dark
            },
            active: {
                border: cardBorder,
                background: rawColors.gray.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        outlined: {
            default: {
                border: cardBorder,
                background: rawColors.white,
                color: rawColors.gray.dark
            },
            hover: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            active: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        attention: {
            default: {
                border: cardBorder,
                background: rawColors.beige.normal,
                color: rawColors.gray.dark
            },
            hover: {
                border: cardBorder,
                background: rawColors.beige.dark,
                color: rawColors.gray.dark
            },
            active: {
                border: cardBorder,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: cardBorder,
                background: rawColors.gray.lightExtreme,
                color: rawColors.gray.light
            }
        },
        none: {
            default: {
                border: rawColors.white,
                background: rawColors.white,
                color: rawColors.gray.dark
            },
            hover: {
                border: rawColors.gray.light,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            active: {
                border: rawColors.gray.light,
                background: rawColors.blue.light,
                color: rawColors.gray.dark
            },
            disabled: {
                border: rawColors.white,
                background: rawColors.white,
                color: rawColors.gray.light
            }
        },
    },
    avatar: {
        background: rawColors.blue.normal,
        backgroundLight: rawColors.blue.light,
        backgroundMuted: rawColors.gray.light,
        userRole: {
            employer: rawColors.blue.dark,
            employee: rawColors.blue.normal,
        },
        text: textColors.white,
        selectedBorder: rawColors.gray.darkExtreme
    },
    table: {
        border: rawColors.gray.light,
        borderInternal: rawColors.gray.lightExtreme,
        headerText: rawColors.gray.dark,
        cellText: rawColors.gray.dark,
        backgroundHover: rawColors.gray.lightExtreme,
        trOdd: rawColors.white,
        trEven: rawColors.gray.lightExtreme
    },
    withSaveButton: {
        cancel: {
            border: rawColors.red.normal,
            borderHover: rawColors.red.dark,
            background: rawColors.white,
            color: rawColors.red.normal,
            colorHover: rawColors.red.dark
        },
        save: {
            border: rawColors.blue.normal,
            borderHover: rawColors.blue.dark,
            background: rawColors.white,
            color: rawColors.blue.normal,
            colorHover: rawColors.blue.dark
        }
    },
    link: {
        dark: {
            normal: 'rgb(47, 45, 151)',
            hover: 'rgb(47, 45, 151, 0.8)',
        },
        default: {
            normal: rawColors.blue.normal,
            hover: rawColors.blue.light
        },
        footer: {
            normal: textColors.normal,
            hover: rawColors.red.normal
        }
    },
    footer: {
        background: rawColors.blue.lightExtreme,
    },
    getUserRoleColor,
    inputState,
    editableInput: {
        backgroundHover: rawColors.gray.lightExtreme,
    },
    divider: {
        default: rawColors.gray.normal,
        light: rawColors.blue.lightExtreme,
    },
    graphs: {
        progressBar: rawColors.blue.normal,
        segmentBar: {
            selected: rawColors.blue.light,
            selectedNeutral: rawColors.gray.light,
            unselected: rawColors.gray.lightExtreme,
        },
        survey: {
            getAnswerAverageColor: getSelectionChartColor,
            answers: {
                veryDissatisfied: 'rgb(215, 178, 51)',
                dissatisfied: 'rgb(254, 204, 89)',
                neutral: 'rgb(126, 177, 104)',
                satisfied: 'rgb(56, 117, 30)',
                verySatisfied: 'rgb(39, 81, 21)'
            },
            groupedAnswers: {
                unfavorable: 'rgb(215, 178, 51)',
                neutral: 'rgb(126, 177, 104)',
                favorable: 'rgb(39, 81, 21)'
            }
        },
        activityTimeline: {
            getColor: (type: ActivityType) =>
            {
                if (type === 'AnnualWorkgroupStatus')
                    return rawColors.blue.normal;
                // return rawColors.blue.dark;
                else if (type === 'WorkgroupMeeting')
                    return rawColors.blue.normal;
                // return rawColors.blue.normal;
                else if (type === 'WorkplaceAssessment')
                    return rawColors.blue.normal;
                // return rawColors.green.light;
                else if (type === 'SafetyInspection')
                    return rawColors.blue.normal;
                // return rawColors.green.dark;
                else if (type === 'CustomForm')
                    return rawColors.blue.normal;
                // return rawColors.blue.light;

                else
                    return rawColors.blue.normal;
            },
            hover: rawColors.beige.normal,
        },
        articleTimeline: {
            getColor: (listName: string) =>
            {
                if (listName === 'Arbejdsmiljø')
                    return rawColors.blue.dark;
                else if (listName === 'Miljø')
                    return rawColors.blue.normal;
                else if (listName === 'Brand')
                    return rawColors.green.light;
                else if (listName === 'Farligt gods')
                    return rawColors.green.dark;
                else if (listName === 'Energi')
                    return rawColors.blue.light;
                else
                    return rawColors.gray.normal;
            },
            hover: rawColors.beige.normal,
        },
        progress: {
            pending: rawColors.gray.light,
            success: rawColors.green.normal,
            error: rawColors.red.normal
        },
        completionPanel: {
            unfavorable: 'rgb(215, 178, 51)',
            neutral: 'rgb(126, 177, 104)',
            favorable: 'rgb(39, 81, 21)'
        }
    },
    onOff: {
        border: rawColors.green.light,
        inactiveBorder: rawColors.gray.lightExtreme,
        fullColor: {
            activeColor: rawColors.green.dark,
            inactiveColor: rawColors.red.dark,
            activeBackground: rawColors.green.light,
            inactiveBackground: rawColors.red.normal
        },
        default: {
            activeColor: rawColors.green.dark,
            inactiveColor: textColors.normal,
            activeBackground: rawColors.green.light,
            inactiveBackground: rawColors.gray.light
        }
    },
    suggester: {
        optionList: {
            background: rawColors.white,
            backgroundHover: rawColors.blue.light,
            border: rawColors.blue.normal,
        }
    },
    text: { ...textColors },
    icon: {
        default: rawColors.gray.dark,
        passive: rawColors.gray.light,
        active: rawColors.blue.dark,
        disabled: rawColors.gray.lightExtreme,
        ...stateColors,
    },
    importance: {
        default: rawColors.gray.dark,
        high: rawColors.red.normal,
        medium: rawColors.yellow.normal,
        low: rawColors.green.light
    },
    tabber: {
        border: rawColors.blue.lightExtreme,
        color: rawColors.gray.normal,
        colorSelected: textColors.normal,
        colorSelected2: rawColors.blue.normal,
        colorDisabled: textColors.muted,
        backgroundSelected: rawColors.blue.lightExtreme,
        backgroundHover: rawColors.blue.light,
    },
    menu: {
        background: rawColors.white,
        backgroundSelected: rawColors.blue.light,
        border: rawColors.gray.light,
        default: {
            backgroundHover: rawColors.blue.light
        },
        emphasized: {
            backgroundHover: rawColors.blue.light
        },
        destructive: {
            backgroundHover: rawColors.red.light
        },
        strikeThrough: {
            backgroundHover: rawColors.blue.light
        }
    },
    listRow: {
        bright: {
            border: rawColors.blue.normal,
            background: rawColors.blue.lightExtreme,
            backgroundHover: rawColors.blue.light,
        },
        normal: {
            border: rawColors.blue.dark,
            background: rawColors.blue.light,
            backgroundHover: rawColors.blue.normal,
        },
        dark: {
            border: rawColors.black,
            background: rawColors.blue.darkExtreme,
            backgroundHover: rawColors.black,
        },
        neutral: {
            border: rawColors.gray.lightExtreme,
            background: rawColors.white,
            backgroundHover: rawColors.blue.lightExtreme
        }
    },
    radialChart: {
        red: rawColors.red.normal,
        green: rawColors.green.normal,
        yellow: rawColors.yellow.normal,
        blue: rawColors.blue.normal,
        unfilled: rawColors.gray.lightExtreme
    },
    radioButtonButton: {
        background: rawColors.white,
        backgroundSelected: rawColors.blue.normal,
        backgroundDisabled: rawColors.gray.lightExtreme,
        border: rawColors.gray.light,
        text: textColors.normal,
        textHover: textColors.white,
        textDisabled: rawColors.gray.light
    },
    buttonRadioButton: {
        background: rawColors.white,
        backgroundHover: rawColors.blue.light,
        backgroundSelected: rawColors.blue.light,
        backgroundDisabled: rawColors.gray.lightExtreme,
        text: textColors.normal,
        textHover: textColors.normal,
        textSelected: textColors.normal,
        textDisabled: rawColors.gray.light,
        border: rawColors.gray.light,
    },
    pill: {
        background: rawColors.white,
        backgroundSelected: rawColors.blue.lightExtreme,
        border: rawColors.blue.light,
        color: textColors.gray.normal,
        colorSelected: textColors.gray.dark
    },
    messageCard: {
        backgroundHover: rawColors.blue.normal,
        success: {
            border: stateColors.success,
        },
        warning: {
            border: stateColors.warning
        },
        error: {
            border: stateColors.error
        },
        info: {
            border: rawColors.blue.light
        }
    },
    org: {
        card: {
            background: {
                root: rawColors.blue.lightExtreme,
                committee: rawColors.white,
                workgroup: rawColors.gray.lightExtreme
            }
        }
    },
    customForm: {
        answer: {
            formFieldHeader: {
                backgroundHover: rawColors.gray.lightExtreme,
                borderHover: rawColors.gray.light
            },
            formFieldCard: {
                cardHeader: {
                    background: rawColors.blue.light,
                    text: textColors.normal,
                },
                body: {
                    background: {
                        default: rawColors.white,
                        attention: rawColors.beige.normal,
                        hover: rawColors.gray.lightExtreme
                    }
                },
                border: rawColors.gray.darkExtreme
            }
        }
    },
    scrollContainer: {
        borderHover: rawColors.blue.lightExtreme
    },
    loadingContainer: {
        background: rawColors.white,
    },
    modal: {
        background: rawColors.white,
    },
    inspectionState: {
        pending: {
            backgroundSelected: rawColors.gray.lightExtreme,
            text: textColors.normal,
            textHover: textColors.normal
        },
        passed: {
            backgroundSelected: rawColors.green.normal,
            text: textColors.white,
            textHover: textColors.white
        },
        failed: {
            backgroundSelected: rawColors.red.normal,
            text: textColors.white,
            textHover: textColors.white

        }
    },
    tooltip: {
        border: rawColors.gray.dark,
        text: textColors.normal
    },
    riskCategory: (category: RiskCategory) =>
    {
        if (category === 'Acceptabel risiko')
            return rawColors.green.light;

        else if (category === 'Lille risiko')
            return rawColors.yellow.normal;

        else if (category === 'Moderat risiko')
            return rawColors.yellow.dark;

        else if (category === 'Høj risiko')
            return rawColors.red.normal;

        else
            return rawColors.gray.light;
    },
    background
};
export type ColorSystem = typeof colors;


function getSelectionChartColor (average: number)
{
    if (average < 1.5)
        return colors.graphs.survey.answers.veryDissatisfied;
    if (average < 2.5)
        return colors.graphs.survey.answers.dissatisfied;
    if (average < 3.5)
        return colors.graphs.survey.answers.neutral;
    if (average < 4.5)
        return colors.graphs.survey.answers.satisfied;

    return colors.graphs.survey.answers.verySatisfied;
}

function getUserRoleColor (roleId: string | null): string
{
    const employerRoles: RoleId[] = [
        'employer', 'employer_rep', 'supervisor',
    ];

    if (employerRoles.find(rid => rid === roleId))
        return colors.avatar.userRole.employer;

    return colors.avatar.userRole.employee;
}